import React from "react";
import "../styles/Aboutus.css";

const AboutUs = () => {
  const message ="Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  return (
    <section className="about-us-section" id="about-us">

      {/* Left Image Area */}
      <div className="about-us-image">
        <img
          src="aboutus.webp"
          alt="About Us"
        />
      </div>

      {/* Right Content Area */}
      <div className="about-us-content">
        <h2>About <span className="highlight">Mahadev</span> Book</h2>
        <p>
          Mahadev Book is a cricket betting and trading website that has
          been in operation since 2010. This service is regarded as the
          largest book exchange platform for cricket betting after Mahadev's
          book. It distinguishes itself from other exchange platforms due to
          its simple deposit and withdrawal options. Mahadev owns or
          operates this website. We communicate exclusively via WhatsApp.
        </p>
        <p>
          Mahadev cricket ID online has lately developed the most recent
          new methods of making money through betting. Users receive their
          cricket IDs promptly online, with 24-hour withdrawal services. With
          over 50,000 pleased consumers, this platform is at the top of the
          book exchange market. It currently has over 200 offline branches.
        </p>

        {/* Buttons */}
        <div className="about-us-buttons">
          <a
           href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-btn"
          >
            Contact Us @ 8888568888
          </a><br /><br />
          <a href="/about" class="more-about-link">
            More About Us <span class="tilted-arrow">&rarr;</span>
          </a>
        </div>
      </div>

    </section>
  );
};

export default AboutUs;
